import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signupUser } from '../api/authApi';
import './AuthPage.css';

const SignupPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [nickname, setNickname] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSignup = async () => {
        if(!email.trim() || !password || !nickname.trim()) {
            setError('모든 항목을 입력하세요.');
            return;
        }

        setError('');
        setLoading(true);
        try {
            await signupUser(email.trim(), password, nickname.trim());
            window.alert('회원가입이 완료되었습니다.');
            navigate('/login');
        } catch (requestError: any) {
            console.error(requestError);
            setError(requestError?.response?.data?.message || '회원가입에 실패했어요.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="signup-page auth-page">
            <section className="auth-intro" aria-labelledby="signup-heading">
                <p className="signup-label">새 계정</p>
                <h1 id="signup-heading" className="signup-title">당신의 판단을 기록하세요.</h1>
                <p>고른 진실과 참여한 토론을 한 계정에 안전하게 이어갑니다.</p>
            </section>

            <form
                className="signup-card auth-form"
                onSubmit={(event) => {
                    event.preventDefault();
                    handleSignup();
                }}
            >
                <div className="auth-field">
                    <label htmlFor="signup-email">이메일</label>
                    <input
                        id="signup-email"
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        className="signup-input"
                    />
                </div>

                <div className="auth-field">
                    <label htmlFor="signup-nickname">닉네임</label>
                    <input
                        id="signup-nickname"
                        type="text"
                        autoComplete="nickname"
                        value={nickname}
                        onChange={(event) => setNickname(event.target.value)}
                        className="signup-input"
                    />
                </div>

                <div className="auth-field">
                    <label htmlFor="signup-password">비밀번호</label>
                    <input
                        id="signup-password"
                        type="password"
                        autoComplete="new-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        className="signup-input"
                    />
                </div>

                {error && <p className="signup-error" role="alert">{error}</p>}

                <button type="submit" className="signup-button" disabled={loading}>
                    {loading ? '가입 중…' : '회원가입'}
                </button>

                <p className="signup-login-link">이미 계정이 있나요? <a href="#/login">로그인</a></p>
            </form>
        </main>
    );
};

export default SignupPage;
